import SendDatalayerEvent from "../Events/BasicEvent";
export default class {
    constructor(pubSub, dataLayer) {
        const eventName = "scrolledToBlockItem";
        pubSub.subscribe(eventName, (eventName, eventData) => {
            SendDatalayerEvent(eventName, eventData, dataLayer);
        });
    }
}
